module.exports = __webpack_public_path__ + "static/img/love_you_effect.e78f399.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/love_you_effect.gif
// module id = rz+o
// module chunks = 1